import { useEffect, useRef, useState } from "react";

import { Icon } from "@/components/Icon";
import { AgentPanel } from "@/components/agent/AgentPanel";

export function AgentBubble() {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      {!open && (
        <button
          ref={triggerRef}
          type="button"
          className="agent-bubble"
          onClick={() => setOpen(true)}
          aria-label="Abrir asistente Casper"
          title="Casper · asistente del Caster"
        >
          <Icon.Bot />
          <span className="agent-bubble__pulse" />
        </button>
      )}
      {open && <AgentPanel onClose={() => setOpen(false)} />}
    </>
  );
}
